/**
 * Configure the "Update your payment method" page
 */
function configure(config)
{
	// Listen for someone to check checkboxes for which invoices they want to pay
	$('input.handle_cocPayMultipleInvoices').change(function() {_rebuildPayMultipleURL(config)});
}

/**
 * Rebuild the URL that the end-customer can click to pay for multiple invoices at once
 *
 * @param config
 * @private
 */
function _rebuildPayMultipleURL(config)
{
	// Grab all of the invoices that they have checked off to pay
	let invoice_tokens = [];
	$('input.handle_cocPayMultipleInvoices:checked').each(function(i, e) {
		invoice_tokens.push($(e).data('invoice_token'));
	});

	$('.handle_cocPayMultipleDiv').addClass('hidden');
	$('.handle_cocPayMultipleButton').attr('disabled', 'disabled');

	// Build the payment URL, and show the button to pay for all those invoices
	if (invoice_tokens.length > 0)
	{
		$('.handle_cocPayMultipleDiv').removeClass('hidden');
		$('.handle_cocPayMultipleButton').removeAttr('disabled');

		if (invoice_tokens.length == 1)
		{
			$('.handle_cocPayMultipleButton').html('Pay ' + invoice_tokens.length + ' Selected Invoice');
		}
		else
		{
			$('.handle_cocPayMultipleButton').html('Pay ' + invoice_tokens.length + ' Selected Invoices');
		}

		$('.handle_cocPayMultipleButton').attr('href', config.url_payForInvoices.replace('PLACEHOLDER', invoice_tokens.join(',')));
	}
}

// This tells Webpack to export these functions so they are
module.exports = {

	// what you want to call it externally : what the function name is internally
	configure: configure
}
